// v17-R1 D4: gelijk houden aan de hoogste CHANGELOG-versie in backend/server.py (een pytest bewaakt dat).
export const APP_VERSIE = 35;
